import { render, staticRenderFns } from "./RangeStatusesColumn.vue?vue&type=template&id=61f54cbd&functional=true"
import script from "./RangeStatusesColumn.vue?vue&type=script&lang=js"
export * from "./RangeStatusesColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports